import { render, staticRenderFns } from "./EditContrat.vue?vue&type=template&id=6572bc69&"
import script from "./EditContrat.vue?vue&type=script&lang=ts&"
export * from "./EditContrat.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports